import { ErrorDetail, LibraryDocumentClient } from '@microsoft/esign.gateway.service.client';
import { ApprovalRequestType } from '../../data/types.generated';
import { getEsignGatewayProvider } from '../../utilities/EsignUtils';
import { fetchAndLog, getEsignGatewayConfiguration } from '../../views/Esign/utils/Authentication/EsignAuthHelpers';

export const uploadFileEsignGateway = async (approvalRequestType: ApprovalRequestType, file: File): Promise<string> => {
    try {
        const configuration = await getEsignGatewayConfiguration(approvalRequestType);
        const provider = getEsignGatewayProvider(approvalRequestType);
        const client = new LibraryDocumentClient(configuration, null, { fetch: fetchAndLog });
        const libraryDocumentId = await client.createLibraryDocument(provider, { data: file, fileName: file.name });
        return libraryDocumentId;
    } catch (error: any) {
        let errorDetail: ErrorDetail | null;
        try {
            errorDetail = JSON.parse(error.response);
        } catch {
            errorDetail = null;
        }

        // error.response is the raw body string, so a property cannot be hung off it: doing so throws
        // "Cannot create property 'data' on string" in strict mode, which would replace the gateway
        // failure - status code and all - with a TypeError. The code goes on the error itself instead.
        if (error instanceof Error && errorDetail?.innerError?.code) {
            (error as Error & { innerErrorCode?: string }).innerErrorCode = errorDetail.innerError.code;
        }

        throw error;
    }
};
